export default "__VITE_ASSET__6tJgIAOg__"